import { Dispatch, SetStateAction, memo } from "react";

export type DispatchType<T> = Dispatch<SetStateAction<T>>;

export type FormInputType<T> = (t: T) => void;

export const genericsMemo: <T>(component: T) => T = memo;
